module.exports = __webpack_public_path__ + "img/puzzle7_4.0cab4e15.jpg";